import importerSelectors from 'modules/shared/importer/importerSelectors';

export default importerSelectors(
  'cluster.importer',
);
